import { formatPublicationDate } from '../../../../../utils/svtDateAndTime';

export const upcomingDates = (validFrom) => {
    const stringUppercase = formatPublicationDate(validFrom).toUpperCase();
    const stringSplit = stringUppercase.split(' ');

    // idag/ikväll/inatt/imorgon 20.00 OR if the date is next year
    if (['IDAG', 'IKVÄLL', 'INATT', 'IMORGON'].indexOf(stringSplit[0]) > -1 || isNaN(stringSplit[1])) {
        return [stringSplit[0], stringSplit[1]];
    }

    return [stringSplit[1], stringSplit[2]];
};
